(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.SharedInventoryLanguage = api;
    api.start(root.document, root.MutationObserver);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  const MASTER_VARIANT_ID = '46782271914283';
  const PURCHASE_LANGUAGE_PROPERTY = 'properties[_purchase_language]';
  const FORM_SELECTOR = 'form[action*="/cart/add"], form[data-type="add-to-cart-form"], form.pf-product-form';

  const variantMappings = Object.freeze({
    '46782271914283': Object.freeze({ masterVariantId: MASTER_VARIANT_ID, language: 'English' }),
    '54635896177006': Object.freeze({ masterVariantId: MASTER_VARIANT_ID, language: 'Tamil' }),
    '54635874255214': Object.freeze({ masterVariantId: MASTER_VARIANT_ID, language: 'Sinhala' }),
  });

  function normalizeVariantId(variantId) {
    if (variantId === null || variantId === undefined) return '';
    return String(variantId).split('/').pop();
  }

  function getMapping(variantId) {
    return variantMappings[normalizeVariantId(variantId)] || null;
  }

  function remapFormData(formData, sourceVariantId) {
    if (!formData || typeof formData.get !== 'function' || typeof formData.set !== 'function') return null;

    const mapping = getMapping(sourceVariantId || formData.get('id'));
    if (!mapping) return null;

    formData.set('id', mapping.masterVariantId);
    formData.set(PURCHASE_LANGUAGE_PROPERTY, mapping.language);
    return mapping;
  }

  function findOrCreateLanguageInput(form) {
    let input = form.querySelector(`[name="${PURCHASE_LANGUAGE_PROPERTY}"]`);
    if (input) return input;

    input = form.ownerDocument.createElement('input');
    input.type = 'hidden';
    input.name = PURCHASE_LANGUAGE_PROPERTY;
    form.appendChild(input);
    return input;
  }

  function remapFormElement(form) {
    if (!form || typeof form.querySelector !== 'function') return null;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return null;

    const sourceVariantId = form.dataset.sharedInventorySourceVariantId || variantInput.value;
    const mapping = getMapping(sourceVariantId) || getMapping(variantInput.value);
    if (!mapping) return null;

    form.dataset.sharedInventorySourceVariantId = normalizeVariantId(sourceVariantId);
    form.dataset.purchaseLanguage = mapping.language;
    variantInput.value = mapping.masterVariantId;
    variantInput.disabled = false;

    const languageInput = findOrCreateLanguageInput(form);
    languageInput.value = mapping.language;
    return mapping;
  }

  function start(document, MutationObserverClass) {
    if (!document || document.documentElement.dataset.sharedInventoryLanguageStarted === 'true') return;
    document.documentElement.dataset.sharedInventoryLanguageStarted = 'true';

    document.querySelectorAll(FORM_SELECTOR).forEach(remapFormElement);

    document.addEventListener('submit', (event) => remapFormElement(event.target), true);
    document.addEventListener(
      'click',
      (event) => {
        const form = event.target && event.target.closest ? event.target.closest('form') : null;
        remapFormElement(form);
      },
      true
    );

    if (!MutationObserverClass) return;
    const observer = new MutationObserverClass((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(FORM_SELECTOR)) remapFormElement(node);
          if (node.querySelectorAll) node.querySelectorAll(FORM_SELECTOR).forEach(remapFormElement);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  return {
    MASTER_VARIANT_ID,
    PURCHASE_LANGUAGE_PROPERTY,
    getMapping,
    remapFormData,
    remapFormElement,
    start,
  };
});
